import Vue from 'vue'
import '@/plugins/filters'
import { createUrl } from './create-url'
import { methods } from './methods'

// jsonLdで構造化データを設定

export const jsonLdSchema = {
  // 施設用のgraphオブジェクトを返す
  getFacilityGraphObject(facility) {
    // 郵便番号をハイフン除去
    const zipCode = Vue.options.filters.replace(facility.zip_code, '-', '')

    // メイン画像をセット
    const mainPhoto =
      process.env.SITE_URL +
      methods.getPhotoUrl({
        photo: facility.main_photo,
        id: facility.id,
        width: 720,
        height: 540
      })

    // サイトURLをセット
    const siteUrl =
      process.env.SITE_URL + createUrl.createFacilityUrl(facility.code)

    // 施設住所をセット、市区町村名を除去
    let streetAddress = facility.address.replace(facility.city, '')
    if (facility.address2) {
      streetAddress = streetAddress + ' ' + facility.address2
    }

    const dataGraphObject = {
      '@type': 'LodgingBusiness',
      address: {
        '@type': 'PostalAddress',
        addressCountry: 'JP',
        addressLocality: facility.city,
        addressRegion: facility.prefecture,
        postalCode: zipCode,
        streetAddress
      },
      image: mainPhoto,
      description: facility.introduction,
      geo: {
        '@type': 'GeoCoordinates',
        longitude: facility.lng,
        latitude: facility.lat
      },
      name: facility.name,
      url: siteUrl,
      telephone: facility.tel
    }

    if (facility.rating && facility.reviews && facility.reviews.length) {
      dataGraphObject.aggregateRating = {
        '@type': 'AggregateRating',
        reviewCount: facility.reviews.length,
        ratingValue: facility.rating
      }
    }

    return dataGraphObject
  },

  // 施設のjson-ldを返す
  getJsonLdFacility(facility) {
    const graph = [this.getFacilityGraphObject(facility)]
    return {
      '@context': 'http://schema.org',
      '@graph': graph
    }
  },

  // 施設検索一覧のjson-ldを返す
  getJsonLdSearchPage(facilities = []) {
    const graph = facilities.map((facility) =>
      this.getFacilityGraphObject(facility)
    )
    return {
      '@context': 'http://schema.org',
      '@graph': graph
    }
  },

  // トップページのjson-ldを返す
  getJsonLdTopPage() {
    const schema = {
      '@context': 'http://schema.org',
      '@type': 'WebSite',
      url: process.env.SITE_URL + '/',
      potentialAction: {
        '@type': 'SearchAction',
        target: process.env.SITE_URL + '/s/?q={search_term_string}',
        'query-input': 'required name=search_term_string'
      }
    }

    return schema
  },
  getJsonLdEvent(eventList = []) {
    const graph = eventList.map((event) => {
      return {
        '@type': 'Event',
        name: event.name,
        description: event.description,
        url: event.url,
        image: event.image,
        organizer: event.office,
        location: {
          '@type': 'Place',
          name: event.place,
          sameAs: event.place_url,
          address: event.address,
          geo: {
            '@type': 'GeoCoordinates',
            latitude: event.lat,
            longitude: event.lon
          }
        },
        offers: {
          '@type': 'Offer',
          url: event.url
        },
        startDate: event.start_date,
        endDate: event.end_date,
        eventStatus: 'https://schema.org/EventScheduled',
        eventAttendanceMode: 'https://schema.org/OfflineEventAttendanceMode'
      }
    })

    return {
      '@context': 'http://schema.org',
      '@graph': graph
    }
  }
}
